import { useState } from "react";
import { Email } from "../../Email/Email";
import { Form } from "../../Form/Form";
import { useTranslation } from "react-i18next";
import "./InfoCollection.scss";
import { Contact } from "../../Contact/Contact";

export const InfoCollection = ({ updateEmail, questionsData, onComplete }) => {
  const { i18n } = useTranslation();
  const [userInfo, setUserInfo] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const loadNextStep = (data) => {
    if (questionsData.length < 1 || activeStep > 1) {
      onComplete({ ...userInfo, ...data, lang: i18n.language });
    } else {
      setUserInfo((prevData) => ({ ...prevData, ...data }));
      setActiveStep((prevValue) => prevValue + 1);
    }
  };

  return (
    <div className={`info-collection ${activeStep === 2 ? "dark-bg" : ""}`}>
      {activeStep === 0 && <Contact updateUserInfo={loadNextStep} />}
      {activeStep === 1 && (
        <Email updateEmail={updateEmail} updateUserInfo={loadNextStep} />
      )}
      {activeStep === 2 && (
        <Form
          formData={questionsData}
          onComplete={loadNextStep}
          onNextQuestion={() => setActiveStep((prevValue) => prevValue + 1)}
        />
      )}
    </div>
  );
};
